import { doc, getDoc, setDoc, updateDoc, arrayUnion } from "firebase/firestore";
import { db } from "../firestore/firestore";

export async function writeNewData(dbObj) {
  try {
    const orderCapLimit = 7; // Maximum number of orders allowed
    const docRef = doc(db, "users", dbObj.email);
    const docSnap = await getDoc(docRef);

    const newOrder = {
      productId: dbObj.orderInfo.productId,
      productName: dbObj.orderInfo.productName,
      quantity: dbObj.orderInfo.quantity,
      timestamp: dbObj.orderInfo.timestamp,
      orderStatus: dbObj.orderInfo.orderStatus,
    };

    if (docSnap.exists()) {
      const existingData = docSnap.data();
      const currentOrderList = existingData.orderlist || [];

      if (currentOrderList.length >= orderCapLimit) {
        alert(
          `You cannot place more than ${orderCapLimit} orders Or contact with us for bulk orders.`
        );
        return false;
      }

      // Append to orderlist
      await updateDoc(docRef, {
        orderlist: arrayUnion(newOrder),
      });
    } else {
      // Create new document with initial orderlist
      await setDoc(docRef, {
        email: dbObj.email,
        userInfo: dbObj.userInfo,
        orderlist: [newOrder],
      });
    }
    return true;
  } catch (e) {
    alert("Error writing data!");
    return false;
  }
}
